define(
    "diy/undo-redo/Api",
    [
        'diy/undo-redo/PluginRegistry',
        'diy/undo-redo/Observable'
    ],
    /**
     *
     * @param {function(new:<module.undoRedo.PluginRegistry>)} PluginRegistry
     * @param {module.undoRedo.Observable} Observable
     * @returns {module.undoRedo.Api}
     */
    function (PluginRegistry, Observable) {
        'use strict';

        /**
         * @class module.undoRedo.Api
         * @template module.undoRedo.Api
         * @lends {module.undoRedo.Api.prototype}
         * @extends {module.undoRedo.Observable}
         * @constructor
         */
        var Api = Observable.extend({
            version: 2,
            /**
             * @type {module.undoRedo.App}
             */
            undoRedo: null,

            /**
             * @type {module.undoRedo.PluginRegistry}
             */
            pluginRegistry: undefined,

            /** @type {module.undoRedo.Settings} */
            settings: null,

            /** @type {module.undoRedo.FeatureSet} */
            features: null,
            /**
             * @constructor
             *
             * @param {module.undoRedo.App} undoRedo
             * @param {module.undoRedo.Settings} settings
             * @param {module.undoRedo.FeatureSet} features
             * @param {module.undoRedo.PluginRegistry} pluginRegistry
             *
             */
            initialize: function (undoRedo, settings, features, pluginRegistry) {
                this.undoRedo = undoRedo;
                this.settings = settings;
                this.features = features;
                this.pluginRegistry = pluginRegistry;
                this.observers = [];
            },

            init: function () {

            },

            /**
             *
             * @param {module.undoRedo.plugins.Base} plugin
             * @returns {module.undoRedo.Api}
             */
            registerPlugin: function (plugin) {
                this.pluginRegistry.register(plugin);
                return this;
            },

            /**
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             * @returns {module.undoRedo.Api}
             */
            enablePlugins: function (featureSet) {
                this.pluginRegistry.enable(featureSet);
                this.pluginRegistry.init();
                return this;
            },

            /**
             * called from history entries to request a page reload to a given url
             * if url is undefined a reload event for the current page will be triggered
             *
             * @param {String=} url
             */
            requestBrowserReload: function (url) {
                return this.undoRedo.requestBrowserReload(url);
            },

            /**
             *
             */
            requestServerSync: function () {
                this.undoRedo.requestServerSync();
            },
            onNewEntryServerSide: function () {
                this.undoRedo.onNewEntryServerSide();
            },

            /**
             *
             * @param entryKey
             * @returns {Promise|Q.Promise}
             */
            executeEntryKey: function executeEntryKey(entryKey) {
                return this.undoRedo.executeEntry(entryKey);
            },
            /**
             *
             * @returns {{getId: Function, add: Function}}
             */
            startSession: function () {
                return this.undoRedo.startSession();
            },

            hideRedoQueue: function () {
                this.undoRedo.uiManager.handle({
                    undo: this.undoRedo.history.chains.undo,
                    redo: [],
                    last: null
                });
            },
            refreshUi: function refreshUi () {
                this.undoRedo.refreshUi();
            },

            /**
             *
             * @returns {Promise|Q.Promise}
             */
            closeActiveSession: function () {
                return this.undoRedo.closeActiveSession();
            },
            /**
             *
             * @param entryType
             * @returns {module.undoRedo.plugins.Base|null|*}
             */
            getPluginForEntryType: function getPluginForEntryType(entryType) {
                return this.pluginRegistry.getPluginFor(entryType);
            },
            onLogout: function onLogout() {
                this.undoRedo.cleanUp();
            },
            onAppReady: function () {
                this.enablePlugins(this.features);
            }
        });

        return Api;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Api.js
 ** module id = 922
 ** module chunks = 0
 **/